import { emptySplitApi as api } from "../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiAdminV1RepositoryRepositoryFilesList: build.query<
      ApiAdminV1RepositoryRepositoryFilesListApiResponse,
      ApiAdminV1RepositoryRepositoryFilesListApiArg
    >({
      query: () => ({ url: `/api/admin/v1/repository/repository-files/` }),
    }),
    apiAdminV1RepositoryRepositoryFilesCreate: build.mutation<
      ApiAdminV1RepositoryRepositoryFilesCreateApiResponse,
      ApiAdminV1RepositoryRepositoryFilesCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/repository/repository-files/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    apiAdminV1RepositoryRepositoryFilesRetrieve: build.query<
      ApiAdminV1RepositoryRepositoryFilesRetrieveApiResponse,
      ApiAdminV1RepositoryRepositoryFilesRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/repository/repository-files/${queryArg.id}/`,
      }),
    }),
    apiAdminV1RepositoryRepositoryFilesUpdate: build.mutation<
      ApiAdminV1RepositoryRepositoryFilesUpdateApiResponse,
      ApiAdminV1RepositoryRepositoryFilesUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/repository/repository-files/${queryArg.id}/`,
        method: "PUT",
        body: queryArg.repositoryFile,
      }),
    }),
    apiAdminV1RepositoryRepositoryFilesPartialUpdate: build.mutation<
      ApiAdminV1RepositoryRepositoryFilesPartialUpdateApiResponse,
      ApiAdminV1RepositoryRepositoryFilesPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/repository/repository-files/${queryArg.id}/`,
        method: "PATCH",
        body: queryArg.patchedRepositoryFile,
      }),
    }),
    apiAdminV1RepositoryRepositoryFilesDestroy: build.mutation<
      ApiAdminV1RepositoryRepositoryFilesDestroyApiResponse,
      ApiAdminV1RepositoryRepositoryFilesDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/repository/repository-files/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
    apiAdminV1RepositoryRepositoryFilesRegenerateEmbeddingsCreate:
      build.mutation<
        ApiAdminV1RepositoryRepositoryFilesRegenerateEmbeddingsCreateApiResponse,
        ApiAdminV1RepositoryRepositoryFilesRegenerateEmbeddingsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/v1/repository/repository-files/${queryArg.id}/regenerate_embeddings/`,
          method: "POST",
        }),
      }),
    apiAdminV1RepositoryRepositoryFilesRetryProcessingCreate: build.mutation<
      ApiAdminV1RepositoryRepositoryFilesRetryProcessingCreateApiResponse,
      ApiAdminV1RepositoryRepositoryFilesRetryProcessingCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/repository/repository-files/${queryArg.id}/retry_processing/`,
        method: "POST",
        body: queryArg.repositoryFile,
      }),
    }),
    apiAdminV1RepositoryRepositoryFilesStreamRetrieve: build.query<
      ApiAdminV1RepositoryRepositoryFilesStreamRetrieveApiResponse,
      ApiAdminV1RepositoryRepositoryFilesStreamRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/repository/repository-files/${queryArg.id}/stream/`,
      }),
    }),
    apiAdminV1RepositoryRepositoryFilesVoteCreate: build.mutation<
      ApiAdminV1RepositoryRepositoryFilesVoteCreateApiResponse,
      ApiAdminV1RepositoryRepositoryFilesVoteCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/repository/repository-files/${queryArg.id}/vote/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    apiAdminV1RepositoryRepositoryFilesVotesRetrieve: build.query<
      ApiAdminV1RepositoryRepositoryFilesVotesRetrieveApiResponse,
      ApiAdminV1RepositoryRepositoryFilesVotesRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/repository/repository-files/${queryArg.id}/votes/`,
      }),
    }),
    apiAdminV1RepositoryRepositoryFilesCreateUrlCreate: build.mutation<
      ApiAdminV1RepositoryRepositoryFilesCreateUrlCreateApiResponse,
      ApiAdminV1RepositoryRepositoryFilesCreateUrlCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/repository/repository-files/create_url/`,
        method: "POST",
        body: queryArg.createUrlInput,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as portalApi };
export type ApiAdminV1RepositoryRepositoryFilesListApiResponse =
  /** status 200  */ RepositoryFileRead[];
export type ApiAdminV1RepositoryRepositoryFilesListApiArg = void;
export type ApiAdminV1RepositoryRepositoryFilesCreateApiResponse =
  /** status 201  */ RepositoryFileRead;
export type ApiAdminV1RepositoryRepositoryFilesCreateApiArg = {
  body: {
    file: Blob;
  };
};
export type ApiAdminV1RepositoryRepositoryFilesRetrieveApiResponse =
  /** status 200  */ RepositoryFileRead;
export type ApiAdminV1RepositoryRepositoryFilesRetrieveApiArg = {
  /** A unique integer value identifying this repository file. */
  id: number;
};
export type ApiAdminV1RepositoryRepositoryFilesUpdateApiResponse =
  /** status 200  */ RepositoryFileRead;
export type ApiAdminV1RepositoryRepositoryFilesUpdateApiArg = {
  /** A unique integer value identifying this repository file. */
  id: number;
  repositoryFile: RepositoryFile;
};
export type ApiAdminV1RepositoryRepositoryFilesPartialUpdateApiResponse =
  /** status 200  */ RepositoryFileRead;
export type ApiAdminV1RepositoryRepositoryFilesPartialUpdateApiArg = {
  /** A unique integer value identifying this repository file. */
  id: number;
  patchedRepositoryFile: PatchedRepositoryFile;
};
export type ApiAdminV1RepositoryRepositoryFilesDestroyApiResponse = unknown;
export type ApiAdminV1RepositoryRepositoryFilesDestroyApiArg = {
  /** A unique integer value identifying this repository file. */
  id: number;
};
export type ApiAdminV1RepositoryRepositoryFilesRegenerateEmbeddingsCreateApiResponse =
  /** status 200  */ {
    status?: string;
    message?: string;
  };
export type ApiAdminV1RepositoryRepositoryFilesRegenerateEmbeddingsCreateApiArg =
  {
    /** A unique integer value identifying this repository file. */
    id: number;
  };
export type ApiAdminV1RepositoryRepositoryFilesRetryProcessingCreateApiResponse =
  /** status 200  */ RepositoryFileRead;
export type ApiAdminV1RepositoryRepositoryFilesRetryProcessingCreateApiArg = {
  /** A unique integer value identifying this repository file. */
  id: number;
  repositoryFile: RepositoryFile;
};
export type ApiAdminV1RepositoryRepositoryFilesStreamRetrieveApiResponse =
  /** status 200  */ RepositoryFileRead;
export type ApiAdminV1RepositoryRepositoryFilesStreamRetrieveApiArg = {
  /** A unique integer value identifying this repository file. */
  id: number;
};
export type ApiAdminV1RepositoryRepositoryFilesVoteCreateApiResponse =
  /** status 200  */ RepositoryFileRead;
export type ApiAdminV1RepositoryRepositoryFilesVoteCreateApiArg = {
  /** A unique integer value identifying this repository file. */
  id: number;
  body: Blob;
};
export type ApiAdminV1RepositoryRepositoryFilesVotesRetrieveApiResponse =
  /** status 200  */ {
    id?: number;
    employee_id?: number;
    employee_first_name?: string;
    employee_last_name?: string;
    employee_email?: string;
    vote?: number;
    feedback_notes?: string | null;
    created_at?: string;
  }[];
export type ApiAdminV1RepositoryRepositoryFilesVotesRetrieveApiArg = {
  /** A unique integer value identifying this repository file. */
  id: number;
};
export type ApiAdminV1RepositoryRepositoryFilesCreateUrlCreateApiResponse =
  /** status 200  */ RepositoryFileRead;
export type ApiAdminV1RepositoryRepositoryFilesCreateUrlCreateApiArg = {
  createUrlInput: CreateUrlInput;
};
export type TypeEnum = 0 | 1 | 2;
export type RepositoryFile = {
  name: string;
  object_key: string;
  type?: TypeEnum;
  size?: number;
  description?: string | null;
  resource_category?: string | null;
  category_ids?: number[];
  source?: string | null;
  tags?: string | null;
  outcomes?: string | null;
  reference?: string | null;
  audience?: any;
};
export type Repository = {
  name: string;
  url: string;
};
export type RepositoryRead = {
  id: number;
  name: string;
  url: string;
};
export type ProcessingStatusEnum = 0 | 1 | 2 | 3;
export type TranscriptionStatusEnum = 0 | 1 | 2 | 3;
export type RepositoryFileRead = {
  id: number;
  name: string;
  object_key: string;
  repository_id: number;
  repository: RepositoryRead;
  type?: TypeEnum;
  size?: number;
  created_at: string;
  updated_at: string;
  share_count: string;
  share_viewed_count: string;
  upvote_count: string;
  downvote_count: string;
  your_vote: string;
  your_feedback_notes: string;
  description?: string | null;
  ai_overview: string | null;
  resource_category?: string | null;
  category_ids?: number[];
  source?: string | null;
  tags?: string | null;
  outcomes?: string | null;
  reference?: string | null;
  audience?: any;
  processing_status: ProcessingStatusEnum;
  processing_error: string | null;
  transcription_status: TranscriptionStatusEnum;
  transcription_error: string | null;
  transcription_completed_at: string | null;
  retry_count: number;
};
export type PatchedRepositoryFile = {
  name?: string;
  object_key?: string;
  type?: TypeEnum;
  size?: number;
  description?: string | null;
  resource_category?: string | null;
  category_ids?: number[];
  source?: string | null;
  tags?: string | null;
  outcomes?: string | null;
  reference?: string | null;
  audience?: any;
};
export type PatchedRepositoryFileRead = {
  id?: number;
  name?: string;
  object_key?: string;
  repository_id?: number;
  repository?: RepositoryRead;
  type?: TypeEnum;
  size?: number;
  created_at?: string;
  updated_at?: string;
  share_count?: string;
  share_viewed_count?: string;
  upvote_count?: string;
  downvote_count?: string;
  your_vote?: string;
  your_feedback_notes?: string;
  description?: string | null;
  ai_overview?: string | null;
  resource_category?: string | null;
  category_ids?: number[];
  source?: string | null;
  tags?: string | null;
  outcomes?: string | null;
  reference?: string | null;
  audience?: any;
  processing_status?: ProcessingStatusEnum;
  processing_error?: string | null;
  transcription_status?: TranscriptionStatusEnum;
  transcription_error?: string | null;
  transcription_completed_at?: string | null;
  retry_count?: number;
};
export type CreateUrlInput = {
  url: string;
  name: string;
  type?: number;
  description?: string | null;
  ai_overview?: string | null;
  source?: string | null;
  tags?: string | null;
  outcomes?: string | null;
  resource_category?: string | null;
  category_ids?: number[];
  reference?: string | null;
  audience?: string | null;
};
export const {
  useApiAdminV1RepositoryRepositoryFilesListQuery,
  useApiAdminV1RepositoryRepositoryFilesCreateMutation,
  useApiAdminV1RepositoryRepositoryFilesRetrieveQuery,
  useApiAdminV1RepositoryRepositoryFilesUpdateMutation,
  useApiAdminV1RepositoryRepositoryFilesPartialUpdateMutation,
  useApiAdminV1RepositoryRepositoryFilesDestroyMutation,
  useApiAdminV1RepositoryRepositoryFilesRegenerateEmbeddingsCreateMutation,
  useApiAdminV1RepositoryRepositoryFilesRetryProcessingCreateMutation,
  useApiAdminV1RepositoryRepositoryFilesStreamRetrieveQuery,
  useApiAdminV1RepositoryRepositoryFilesVoteCreateMutation,
  useApiAdminV1RepositoryRepositoryFilesVotesRetrieveQuery,
  useApiAdminV1RepositoryRepositoryFilesCreateUrlCreateMutation,
} = injectedRtkApi;
